import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { rotaDeTela } from '@/features/permissoes/guardas';
import { DetalheDoPlano } from '@/features/planos/componentes/DetalheDoPlano';

const busca = z.object({ ficha: z.uuid().optional().catch(undefined) });

/** Página do plano com as fichas (spec 009, CA-03). */
export const Route = createFileRoute('/_autenticado/planos/$id')({
  ...rotaDeTela('planos.lista'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const { id } = Route.useParams();
  const { ficha } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DetalheDoPlano
      key={id}
      id={id}
      vinculoAberto={ficha}
      aoAbrirFicha={(vinculoId) => {
        void navigate({ search: { ficha: vinculoId } });
      }}
    />
  );
}
